/* eslint-disable import/prefer-default-export */
export class PriceFormatter {
  static formatStringAsPrice = (value: string, moneda?: string) => {
    const price = Number(value.toString().replace(/,/g, '.'));
    if (price > 999 && price < 10000) {
      const b = price / 1000;
      const c = b.toLocaleString('es-ES').charAt(0).concat('.');
      const d = price
        .toString()
        .replace(price.toLocaleString('es-ES').charAt(0), c);
      return `${d}${moneda == null ? '' : moneda}`;
    }
    return `${price.toLocaleString('es-ES')}${moneda == null ? '' : moneda}`;
  };
}
